import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment/moment";
import { Button, FormControl, Modal, Table } from "react-bootstrap";
import { clientBalanceHistory, clientBalanceHistoryUpdate } from "../../../../api/cp/client";
import Loading from "../../Loading";
import { getClientNickname } from "../../../tools";

const actionTypes = {
    comment: "Сообщение",
    commentReply: "Ответ на сообщение",
    pollAnswer: "Ответ на опрос",
    question: "Вопрос",
    questionLike: "Лайк вопроса",
    speakerQuestion: "Вопрос спикеру",
    quizPassed: "Пройден квиз",
    registration: "Регистрация",
    longViewing: "Длительный просмотр",
    orderPaid: "Оплата заказа",
    quizQuestionCorrectAnswer: "Правильный ответ на вопрос в квизе",
    manualChange: "Обновлено вручную",
    refund_quizPassed: "Пройден квиз: операция отменена",
    refund_comment: "Сообщение: операция отменена",
    refund_commentReply: "Ответ на сообщение: операция отменена",
    refund_pollAnswer: "Ответ на опрос: операция отменена",
    refund_question: "Вопрос: операция отменена",
    refund_quizQuestionCorrectAnswer: "Правильный ответ на вопрос в квизе: операция отменена",
    refund_speakerQuestion: "Вопрос спикеру: операция отменена",
    refund_questionLike: "Лайк вопроса: операция отменена",
    refund: "Операция возврата",
}

const balanceActionTypes = [
    {
        value: 'increase',
        label: 'Начислить',
    },
    {
        value: 'reduce',
        label: 'Списать',
    },
]

export default ({ event, client, updateClient, onHide = () => { } }) => {

    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [balanceDiff, setBalanceDiff] = useState(0);
    const [balanceAction, setBalanceAction] = useState(balanceActionTypes[0].value);

    const clientBalance = parseInt(client?.balance || 0);
    const updateBalanceDisabled = !balanceDiff || (balanceAction === 'reduce' && balanceDiff > clientBalance);

    const getData = async (client) => {
        setLoading(true);
        try {
            const response = await clientBalanceHistory(client.reg_id);
            setTableData(response || []);
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (client) {
            getData(client)
        } else {
            setTableData([])
        }
    }, [client])

    const updateAction = (type) => {
        setBalanceAction(type.value);
        if (type.value === 'reduce' && balanceDiff > clientBalance) {
            setBalanceDiff(clientBalance)
        };
    }

    const updateBalance = async () => {
        try {
            const response = await clientBalanceHistoryUpdate(event.eventKey, client.reg_id, balanceAction, { balanceDiff });
            if (Array.isArray(response)) {
                setTableData(response);
                updateClient({ ...client, balance: response[response.length - 1]?.balance })
            }
            setBalanceDiff(0);
        } catch (e) {
            console.error(e)
        }
    }

    return <Modal show={!!client} onHide={onHide} bsSize="large">
        <Modal.Header closeButton>
            <Modal.Title>История изменения баланса пользователя {getClientNickname(client)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {(loading && !tableData.length) ?
                <div style={{ height: '10rem' }}><Loading /></div>
                :
                <>
                    {updateClient && <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', alignItems: 'center' }}>
                        <Select
                            name="balanceActionTypes"
                            options={balanceActionTypes}
                            value={balanceActionTypes.find(type => type.value === balanceAction)}
                            onChange={updateAction}
                        />
                        <FormControl
                            type="number"
                            value={balanceDiff}
                            onChange={e => setBalanceDiff(parseInt(e.target.value))}
                            min={0}
                            max={balanceAction === 'reduce' ? clientBalance : null}
                            style={{ width: '10rem', height: 37 }}
                        />
                        <span>баллов</span>
                        <Button
                            bsStyle="success"
                            style={{ marginLeft: '3rem' }}
                            onClick={updateBalance}
                            disabled={updateBalanceDisabled}
                        >
                            {balanceActionTypes.find(type => type.value === balanceAction)?.label}
                        </Button>
                    </div>}
                    <Table style={{ margin: 0 }}>
                        <thead>
                            <tr>
                                <th style={{ width: 150 }}>Дата и время</th>
                                <th>Тип действия</th>
                                <th style={{ width: 80, textAlign: 'right' }}>Добавлено</th>
                                <th style={{ width: 80, textAlign: 'right' }}>Баланс</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map(({ id, createdAt, action, balanceDiff, balance }) =>
                                <tr key={id}>
                                    <td>{moment.unix(createdAt).format('DD.MM.YY HH:mm:ss')}</td>
                                    <td>{actionTypes[action] || ''}</td>
                                    <td style={{ textAlign: 'right' }}>{balanceDiff}</td>
                                    <td style={{ textAlign: 'right' }}><b>{balance}</b></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </>
            }
        </Modal.Body>
    </Modal>
}